import './task-page-2024-task.css'
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FlatBadge } from '../../DanitComponents/Badges/FlatBadge';
import { BsPersonFill } from 'react-icons/bs';
const TaskPage2024Task = ({task, activeTask}) => {
    const { 
        setNodeRef, 
        attributes, 
        listeners, 
        transform, 
        transition,
        isDragging 
    } = useSortable({
          id: task.id,
          data: { 
            task,
            type: "task" 
          },
        });

        const myStyle = {
            transform: CSS.Transform.toString(transform),
            transition,
          };

    if (isDragging) {
        return (<div className="task-page-2024__task-dragging" ref={setNodeRef} style={myStyle} {...attributes} {...listeners}></div>)
    }

    if (activeTask) {
      return (<div className='task-page-2024-task__active' ref={setNodeRef} style={myStyle} {...attributes} {...listeners} >
      {task.title}
    </div>)
    }

    return (
        <div className='task-page-2024-task' ref={setNodeRef} style={myStyle} {...attributes} {...listeners} >
          <div className='task-page-2024-task__task-name'>{task.title}</div>
          <div className='task-page-2024-task__badge'>
            <FlatBadge text='Call' color={{background: 'bg-orange-100', text: 'text-orange-500'}} />
          </div>
          {task.assignee ? 
          <div className='task-page-2024-task__image-wrapper'>
            <img className='admin-note-fall-2023-admin-image' alt='author-pic' src={`https://app.atharo.app/${task.assignee.toLowerCase().replace(/\s/g, '')}.jpg`}/>
          </div>
          : 
          <div className='task-page-2024-task__image-wrapper' style={{backgroundColor: '#E2E8F0', borderRadius: '50%', padding: '5px'}}>
            <BsPersonFill size={19} className='task-page-2024-task__image' />
          </div>}
        </div>
    )
}
export default TaskPage2024Task